import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import ToastHandler from '../../components/toasthandler';
import Loader from '../../components/loader';

// import Pagination from '../../components/pagination';
import {
  fetchLoginSessions,
  expireLoginSession,
} from '../../actions';

const dateFormat = 'L LT';

class Sessions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
    };
    this.setCurrentPage = this.setCurrentPage.bind(this);
    this.updateSessions = this.updateSessions.bind(this);
    this.expireSession = this.expireSession.bind(this);
  }

  componentDidMount() {
    this.updateSessions();
  }

  setCurrentPage(number) {
    const { currentPage } = this.state;
    if (currentPage !== number) {
      this.setState({
        currentPage: number,
      });
      this.updateSessions(number);
    }
  }

  updateSessions(page) {
    const { dispatch } = this.props;
    const data = {
      limit: 10,
      page: 1,
    };
    if (page) {
      data.page = page;
    }
    dispatch(fetchLoginSessions(data));
  }

  expireSession(refId) {
    const { dispatch } = this.props;
    const data = {
      session: refId
    };
    dispatch(expireLoginSession(data))
      .then((res) => {
        if (res.type === 'EXPIRE_LOGIN_SESSION_SUCCESS') {
          this.updateSessions();
        }
        return;
      });
  }

  render() {
    const { loginSessions, user, errors, success } = this.props;
    const { currentPage } = this.state;


    const loginLoop = loginSessions && loginSessions.length && loginSessions.map((item, index) => {
      let browserName;
      let osName;
      let lastActive;
      let refId;
      let pubIp;
      let isLastSession;
      if (item && item.browser && item.browser.name) {
        browserName = item.browser.name;
      }
      if (item && item.os && item.os.name) {
        osName = item.os.name;
      }
      if (item && item.referenceId) {
        refId = item.referenceId;
      }
      if (item && item.publicIP) {
        pubIp = item.publicIP;
      }
      if (item && item.lastActive) {
        lastActive = moment(item.lastActive).format(dateFormat)
      }

      if (index === (loginSessions.length - 1)) {
        isLastSession = true;
      }

      let useIcon = <FontAwesomeIcon icon={faGlobe} className="mute" />;

      if (browserName) {
        switch (browserName.toUpperCase()) {
          case 'AMAZON SILK':
            useIcon = <img alt={browserName} src={ process.env.REACT_APP_CDN + '/assets/images/browsers/amazon-silk.png'} />;
            break;
          case 'BRAVE':
            useIcon = <img alt={browserName} src={ process.env.REACT_APP_CDN + '/assets/images/browsers/brave.png'} />;
            break;
          case 'CHROME':
            useIcon = <img alt={browserName} src={ process.env.REACT_APP_CDN + '/assets/images/browsers/chrome.png'} />;
            break;
          case 'CHROMIUM':
            useIcon = <img alt={browserName} src={ process.env.REACT_APP_CDN + '/assets/images/browsers/chromium.png'} />;
            break;
          case 'ELECTRON':
            useIcon = <img alt={browserName} src={ process.env.REACT_APP_CDN + '/assets/images/browsers/electron.png'} />;
            break;
          case 'FIREFOX':
            useIcon = <img alt={browserName} src={ process.env.REACT_APP_CDN + '/assets/images/browsers/firefox.png'} />;
            break;
          case 'FOCUS':
            useIcon = <img alt={browserName} src={ process.env.REACT_APP_CDN + '/assets/images/browsers/firefox-focus.png'} />;
            break;
          case 'INTERNET EXPLORER':
            useIcon = <img alt={browserName} src={ process.env.REACT_APP_CDN + '/assets/images/browsers/internet-explorer.png'} />;
            break;
          case 'MICROSOFT EDGE':
            useIcon = <img alt={browserName} src={ process.env.REACT_APP_CDN + '/assets/images/browsers/edge.png'} />;
            break;
          case 'OPERA':
            useIcon = <img alt={browserName} src={ process.env.REACT_APP_CDN + '/assets/images/browsers/opera.png'} />;
            break;
          case 'PUFFIN':
            useIcon = <img alt={browserName} src={ process.env.REACT_APP_CDN + '/assets/images/browsers/puffin.png'} />;
            break;
          case 'SAFARI':
            useIcon = <img alt={browserName} src={ process.env.REACT_APP_CDN + '/assets/images/browsers/safari.png'} />;
            break;
          case 'SAMSUNG INTERNET FOR ANDROID':
            useIcon = <img alt={browserName} src={ process.env.REACT_APP_CDN + '/assets/images/browsers/samsung.png'} />;
            break;
          default:
            useIcon = <FontAwesomeIcon icon={faGlobe} className="mute" />;
        }
      }

      const key = `ip-${index}`;
      return (
        <>
          <tr className="hide-mob" key={key}>
            <td>
              <div className="flex-img-head">
                <div>
                  {useIcon}
                </div>
                <div>
                  <span>
                    {browserName} ({osName})
                  </span>
                </div>
              </div>
            </td>
            <td>
              {pubIp}
            </td>
            <td>
              {lastActive}
            </td>
            <td className="flex-end">
              <button type="button" className="vlt-btn vlt-btn-outline" onClick={() => this.expireSession(refId)} disabled={!refId}>
                <span>
                  Log out
                </span>
              </button>
            </td>
          </tr>
          <div className="show-mob cell small-12 medium-12 large-12" key={key}>
            <div className="grid-x align-middle">
              <div className="cell small-12 medium-12 large-12">
                <div className="flex-img-head">
                  <div>
                    {useIcon}
                  </div>
                  <div>
                    <span className="mute">
                      {browserName} ({osName})
                    </span>
                    <span className="mute">
                      <b>IP:</b> {pubIp}
                    </span>
                    <span className="mute">
                      <b>Date:</b> {lastActive}
                    </span>
                  </div>
                </div>
              </div>
              <div className="cell small-12 medium-12 large-12" style={{marginTop: 24, marginBottom: 24}}>
                <button type="button" className="vlt-btn wide vlt-btn-outline" onClick={() => this.expireSession(refId)} disabled={!refId}>
                  Log out
                </button>
                {isLastSession ? (null) : (
                  <hr/>
                )}
              </div>
            </div>
          </div>
        </>
      );
    });

    return (
      <div className="grid-x">
        <ToastHandler errors={errors} success={success} />
        <div className="cell small-12 medium-12 large-12" style={{marginBottom: 20}}>
          <a className="backlink" href="/settings">
            <FontAwesomeIcon
              size="sm"
              icon={faChevronLeft}
            />
            &nbsp;
            Back to Settings
          </a>
        </div>
        <div className="cell panel v2 small-12 medium-12 large-12">
          <div className="panel-label">
            Login Sessions
          </div>
          <div className="cell small-12 medium-12 large-12">
            <div className="hide-mob">
              {loginSessions && loginSessions.length ? (
                <>
                  <table className="session-table">
                    <thead>
                      <tr>
                        <th>Session</th>
                        <th>IP</th>
                        <th>Date</th>
                        <th className="text-right">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loginLoop}
                    </tbody>
                  </table>
                </>
              ) : (
                <>
                  <table className="session-table">
                    <thead>
                      <tr>
                        <th>Session</th>
                        <th className="text-right">Action</th>
                      </tr>
                    </thead>
                  </table>
                  <h3 className="no-data">No Login Sessions</h3>
                </>
              )}
            </div>
            <div className="show-mob">
              {loginSessions && loginSessions.length ? (
                <div className="grid-x align-middle">
                  {loginLoop}
                </div>
              ) : (
                <div className="grid-x align-middle">
                  <h3>No Login Sessions</h3>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.user.errors,
  success: state.user.success,
  loginSessions: state.user.loginSessions,
});

export default connect(mapStateToProps)(Sessions);
